<template>
<div class="chapter">
<div class="inner_page">
<section>
<h2 class="fm_head" id="_idParaDest-1"><a href="#/text/9780062970596_Contents#r_idParaDest-1"><span class="right_1" epub:type="pagebreak" id="page_v" title="v">Dedication</span></a></h2>
<p class="ded_txt"><i>For my great-grandmother Phoebe Sly.</i></p>
<p class="ded_txt"><i>I wish that your story had ended differently.</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062970596_Dedication.vue?8077036a